<template>
    <el-dialog title="导入" width="640px" :model-value="modelValue" @close="closed" :close-on-click-modal="false">
        <el-form ref="formRef" :model="formData" label-width="120px" style="max-width: 540px" :rules="formRules">
            <el-form-item label="选择文件" prop="excel_file_name">
                <el-input placeholder="请选择上传文件" v-model="formData.excel_file_name" disabled>
                    <template #append>
                        <el-upload
                            ref="upload"
                            action="#"
                            :limit="1"
                            :auto-upload="false"
                            :show-file-list="false"
                            :http-request="httpRequest"
                            :on-change="beforeUpload"
                        >
                            <template #trigger>
                                <el-button type="primary">选择文件</el-button>
                            </template>
                        </el-upload>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item>
                <p>支持.xls,.xlsx格式的文件</p>
            </el-form-item>
            <el-form-item>
                <a href="#" style="color: blue" @click="downloadTem">模板下载</a>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, ref } from 'vue'
import { downloadDictData, importsDictData } from '@/api/dictdata.js'
import { ElMessage } from 'element-plus'

const emits = defineEmits(['update:modelValue', 'updateForm'])
defineProps({
    modelValue: {
        type: Boolean,
        required: true
    }
})
// 表单源
const formData = ref({
    excel_file_name: null
})

const formRules = ref({
    excel_file_name: [
        {
            required: true,
            trigger: 'blur',
            message: '请选择上传文件'
        }
    ]
})

const submitLoading = ref(false)
const formRef = ref(null)
/**
 * 关闭
 */
const closed = () => {
    emits('update:modelValue', false)
    formRef.value.resetFields()
}
const httpRequest = () => {}
const downloadTem = () => {
    downloadDictData().then((data) => {
        window.open(data.data)
    })
}

const onConfirm = () => {
    formRef.value.validate(async (valid) => {
        if (valid) {
            const formData = new FormData()
            formData.append('excel_file', excelFile.value)
            importsDictData(formData).then((data) => {
                ElMessage.success('导入成功')
                emits('updateForm')
                closed()
            })
        }
    })
}

const excelFile = ref('')
const beforeUpload = (file) => {
    excelFile.value = file.raw
    formData.value.excel_file_name = file.name
}
</script>

<style lang="scss" scoped>
:deep(.el-input-group__append, .el-input-group__prepend) {
    background-color: var(--theme-color);
    color: #ffffff;
}
</style>
